// extracted by mini-css-extract-plugin
module.exports = {"snackBar":"snackBarRenderer_snackBar__1mJe5","snackAction":"snackBarRenderer_snackAction__3oWRl","spaceBlock":"snackBarRenderer_spaceBlock__3CMPq"};